import { CheckboxLabel } from '@edulastic/common'
import { accommodationsSettings } from '@edulastic/constants/const/test'
import React from 'react'
import { getTtsDescription } from '../utils/accommodations'
import DetailsTooltip from '../AssignTest/components/Container/DetailsTooltip'
import SettingContainer from '../AssignTest/components/Container/SettingsContainer'

const PassageTTSSettingCheckbox = ({
  updateTestData,
  overRideSettings,
  checked,
  disabled,
  setting,
  accommodationsData,
  showTooltip = false,
  tootltipWidth,
  premium = true,
}) => {
  // Get TTS description for tooltip
  const featureDescription = showTooltip
    ? getTtsDescription(
        accommodationsData[
          accommodationsSettings.textToSpeech.key
        ]?.settings.find(
          (s) => s.key === accommodationsSettings.textToSpeech.key
        )?.value,
        checked
      )
    : ''

  const handleChange = (e) => {
    updateTestData // from test page
      ? updateTestData(setting.key)(e.target.checked)
      : overRideSettings // from assignment page
      ? overRideSettings(setting.key, e.target.checked)
      : () => {}
  }

  const isDisabled =
    disabled ||
    !premium ||
    accommodationsData[accommodationsSettings.textToSpeech.key].settings.find(
      (s) => s.key === accommodationsSettings.textToSpeech.key
    )?.value === false

  const checkboxContent = (
    <CheckboxLabel
      onChange={(e) => handleChange(e)}
      checked={checked}
      textTransform="none"
      disabled={isDisabled}
      data-cy="textToSpeechForPassages"
    >
      {setting.title}
    </CheckboxLabel>
  )

  if (showTooltip) {
    return (
      <SettingContainer id={setting.key}>
        <DetailsTooltip
          width={tootltipWidth}
          title={setting.title}
          content={featureDescription}
          premium={premium}
          placement="rightTop"
        />
        {checkboxContent}
      </SettingContainer>
    )
  }

  return checkboxContent
}

export default PassageTTSSettingCheckbox
